import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import { getPathfinderUrl } from '../../../util/util';
import { getConfigObject } from '../../../util/config';
import s from './skillsOverviewReport.module.css';
import ReportError from '../ReportError';
import { ReflectionCard, ReviewedFeedbackCard, AverageRubricCard } from './components';
import { refreshReport as refreshReportAction } from '../../../actions/reports';
import { REPORT_KEYS } from '../../../actions/constants';

class SkillsOverviewReport extends Component {
  componentDidMount() {
    this.props.refreshReport(REPORT_KEYS.skillsOverview);
  }

  render() {
    if (this.props.loading) {
      return (
        <div className={s.loadingWrapper}>
          <div className={s.loadingContainer}>
            <Spinner className={s.mlLoading} />
          </div>
        </div>);
    }

    const {
      loading,
      reports: {
        courseAbstract: {
          id,
        },
        skillsOverview: {
          error,
          feedbackSummary,
          reflectionResponses,
          rubricData,
          hasPathfinderActivity,
        },
      },
      onTabChange,
    } = this.props;

    const { DASHBOARDS_ENABLED_SKILLS_RUBRIC_SCORES } = getConfigObject();

    const renderDiagnosticsButton = () => {
      const url = getPathfinderUrl(id);
      return (
        <a
          className={s.btnPrimary}
          href={url}
          rel="noopener noreferrer"
        >
          View Diagnostics Reports
        </a>
      );
    };
    if (error) return <ReportError />;
    return (
      <div className={s.skillsContainer}>
        <div className={s.headerContainer}>
          <h1 className={s.title}>Course Performance</h1>
          {hasPathfinderActivity &&
            <div className={s.diagnostic}>{renderDiagnosticsButton()}</div>
          }
        </div>
        {DASHBOARDS_ENABLED_SKILLS_RUBRIC_SCORES && rubricData &&
          <AverageRubricCard
            data={rubricData.scores}
            loading={loading}
            nullState={!rubricData.scores || !rubricData.scores.length || !rubricData.assignments || !rubricData.assignments.length}
            rubricAssignments={rubricData.assignments}
          />
        }
        <ReflectionCard
          onTabChange={onTabChange}
          data={reflectionResponses}
          loading={loading}
        />
        <ReviewedFeedbackCard
          data={feedbackSummary.commentTypes}
          loading={loading}
          onTabChange={onTabChange}
          studentsNotViewedFeedback={feedbackSummary.reviewedNone}
        />
      </div>
    );
  }
}

SkillsOverviewReport.propTypes = {
  history: PropTypes.object,
  onTabChange: PropTypes.func,
  refreshReport: PropTypes.func,
  reports: PropTypes.object,
  loading: PropTypes.bool,
};

const mapDispatchToProps = dispatch => bindActionCreators({ refreshReport: refreshReportAction }, dispatch);

function mapStateToProps(state) {
  return {
    reports: state.reports,
    loading: !state.reports.courseAbstract || state.reports.courseAbstract.loading || !state.reports.skillsOverview || state.reports.skillsOverview.loading,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SkillsOverviewReport);
